import env from '../utils/env';
import request from './api/request';

export function getGwpTest() {
  const requestUrl = `${env.abTestPath}/variants/self/preselected?testId=${env.abTestGwpId}`;
  return request(requestUrl);
}
